import { render, staticRenderFns } from "./PTuseLandTotalChart.vue?vue&type=template&id=4c739d92&scoped=true"
import script from "./PTuseLandTotalChart.vue?vue&type=script&lang=js"
export * from "./PTuseLandTotalChart.vue?vue&type=script&lang=js"
import style0 from "./PTuseLandTotalChart.vue?vue&type=style&index=0&id=4c739d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c739d92",
  null
  
)

export default component.exports